class DialogQuickBuy extends HTMLElement {
  connectedCallback () {
    this.dialog = this.querySelector('[data-dialog-quick-buy-el="dialog"]')
    this.selectionWrappers = this.querySelectorAll('[data-dialog-quick-buy-el="selectionWrapper"]')
    this.selections = this.querySelectorAll('[data-dialog-quick-buy-el="selection"]')
    this.notifyMe = this.querySelector('[data-dialog-quick-buy-el="notifyMe"]')
    this.form = this.querySelector('[data-dialog-quick-buy-el="form"]')
    this.inner = this.querySelector('[data-dialog-quick-buy-el="inner"]')
    this.addToCartButton = this.querySelector('[data-dialog-quick-buy-el="atcButton"]')
    this.closeButton = this.querySelector('[data-dialog-quick-buy-el="close"]')
    this.onlyAvailableInStoreButton = this.querySelector('[data-dialog-quick-buy-el="only-available-in-store-trigger"]')

    this.cartItems = document.querySelector('cart-items')

    this.setEventListeners()
  }

  setEventListeners () {
    this.addEventListener('submit', this.onSubmit.bind(this))

    this.selections.forEach(selection => {
      selection.addEventListener('change', this.onSelectionChange.bind(this))
    })

    if (this.onlyAvailableInStoreButton) {
      this.onlyAvailableInStoreButton.addEventListener('click', this.close.bind(this))
    }

    this.closeButton.addEventListener('click', this.close.bind(this))

    this.dialog.addEventListener('click', (event) => {
      if (!this.inner.contains(event.target)) {
        this.close()
      }
    })
  }

  onSelectionChange (event) {
    const selectionWrapper = event.currentTarget.closest('[data-dialog-quick-buy-el="selectionWrapper"]')
    const isAvailable = selectionWrapper.dataset.available === 'true'

    if (isAvailable) {
      this.addToCartButton.ariaHidden = false
      this.addToCartButton.disabled = false
      this.addToCartButton.textContent = 'Add to cart'

      this.notifyMe.ariaHidden = true
    } else {
      this.notifyMe.parentElement.dataset.bisNotificationVariant = event.currentTarget.parentElement.innerText
      this.notifyMe.parentElement.dataset.bisNotificationId = event.currentTarget.id

      this.addToCartButton.ariaHidden = true
      this.notifyMe.ariaHidden = false
    }
  }

  onSubmit (event) {
    event.preventDefault()
    this.addToCartButton.disabled = true
    this.addToCartButton.textContent = 'Adding to cart...'

    const formData = new FormData(this.form)

    if (this.cartItems) {
      formData.append('sections', this.cartItems.getSectionsToRender().map((section) => section.id))
      formData.append('sections_url', window.location.pathname)
    }

    const body = new URLSearchParams(formData).toString()

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body,
    })
      .then(response => response.json())
      .then(json => {
        this.addToCartButton.textContent = 'Added to cart'
        this.close()
        this.cartItems?.renderContents(json)
        setTimeout(() => {
          this.addToCartButton.textContent = 'Add to cart'
          this.addToCartButton.disabled = true
        }, 2000)

        const root = this.dataset.root

        if (root === 'category' || root === 'searchResults') {
          window.theme.tagalys.results.eventBus.publish('results:tracking:product:added', {
            type: root === 'category' ? 'category' : 'serp',
            productId: json.id,
            url: json.url,
          })
        }
      })
      .catch(error => {
        console.error('Error:', error)
      })
  }

  close () {
    const dialogInner = this.querySelector('[data-dialog-quick-buy-el="inner"]')
    if (dialogInner && dialogInner.classList.contains('dialog-transition-active')) {
      dialogInner.classList.remove('dialog-transition-active')

      dialogInner.addEventListener('transitionend', () => {
        const event = new CustomEvent('quick-add:clear', { bubbles: true })
        this.dispatchEvent(event)
      }, { once: true })
    } else {
      const event = new CustomEvent('quick-add:clear', { bubbles: true })
      this.dispatchEvent(event)
    }
  }

  openCart () {
    document.querySelector('#cart-icon-bubble').click()
  }
}

customElements.define('dialog-quick-buy', DialogQuickBuy)
